import { Component, Input, Output, OnInit, ViewChild, EventEmitter } from '@angular/core';
import { IMAGEVIEWER_CONFIG, ImageViewerConfig } from '@hallysonh/ngx-imageviewer';
import { CHttp } from '../services/chttp.service';
import { config } from '../../app.config';
import { AuthDataStorageService } from '../../auth/services/auth-data-storage.service';
import * as moment from 'moment';
import { NgForm } from '@angular/forms';
import { SubscriptionPlansService } from '../../subscription-plans/services/subscription-plans.service';

declare var jQuery: any;

@Component({
  selector: 'ch-add-subscription-modal-dialog',
  templateUrl: './add-subscription-modal-dialog.component.html',
  styleUrls: ['./add-subscription-modal-dialog.component.css']
})
export class AddSubscriptionModalDialogComponent implements OnInit {
  @Input() public show: boolean;
  @Input() public data: any;
  @Output() public onClose: EventEmitter<any> = new EventEmitter();
  @Output() public onAdd: EventEmitter<any> = new EventEmitter();
  @ViewChild('modal') private modal;
  public loading: boolean;
  private period: any;
  private change: boolean;
  plansList: any;

  @ViewChild('form') public form: NgForm;

  public item: any = {};

  constructor(
    private http: CHttp,
    private authDataStorageService: AuthDataStorageService,
    private subscriptionPlansService: SubscriptionPlansService
  ) { }

  ngOnInit() {
    this.subscriptionPlansService.getAppPlansShort().subscribe(res => {
      this.plansList = res.json();
    });
  }

  ngOnChanges() {
    if (this.show) {
      this.change = true;
    }
  }

  ngAfterViewChecked() {
    if (this.change) {
      jQuery(this.modal.nativeElement)
        .modal({
          backdrop: false
        })
        .on('hidden.bs.modal', e => {
          this.onClose.emit(e);
        });

      this.change = false;
    }
  }

  public add() {
    if (!this.form.valid) {
      for (const i in this.form.controls) {
        this.form.controls[i].markAsTouched();
      }

      return;
    }

    this.onAdd.emit(this.item);

    this.item = {};
    this.closeDialog();
  }

  private closeDialog() {
    jQuery(this.modal.nativeElement).modal('hide');
  }

  public endDateChanged(value) {
    const d = new Date(value._d);
    this.item.endsAt = moment(d).format('YYYY-MM-DD');
    this.item.startsAt = moment(new Date()).format('YYYY-MM-DD');
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/core/add-subscription-modal-dialog/add-subscription-modal-dialog.component.ts